<template>
  <div class="flex items-center">
    <p>{{ confirmedCount }} 人</p>
  </div>
</template>

<script>
export default {
  name: "CellRendererConfirmerCount",
  computed: {
    confirmedCount() {
      let confirmedCount = this.params.value.filter(confirmStatus => confirmStatus.confirm_at !== null).length;
      return confirmedCount;
    }
  },
};
</script>
